import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, GungAnonymousConfigService, GungFlowService, LocationConfigService, PriceService, Product, ProductGridViewComponent } from 'gung-standard';
import { takeUntil } from 'rxjs';

@Component({
    selector: 'gung-jeeves-jeeves-product-grid-view',
    templateUrl: './jeeves-product-grid-view.component.html',
    styleUrls: ['./jeeves-product-grid-view.component.css'],
    standalone: false
})
export class JeevesProductGridViewComponent extends ProductGridViewComponent implements OnInit {
  adjustedScroll = false;

  constructor(
    protected priceService: PriceService,
    protected gungFlowService: GungFlowService,
    protected authService: AuthService,
    protected gungAnonymousConfigService: GungAnonymousConfigService,
    protected router: Router,
    protected locationConfigService: LocationConfigService
  ) {
    super(priceService, gungFlowService, authService, gungAnonymousConfigService, router);
  }

  ngOnInit() {
    super.ngOnInit();

    this.mappedDataChanged
      .asObservable()
      .pipe(takeUntil(this.unsubscribe))
      .subscribe(() => {});
  }


  getPreviousLayout(): number {
    const defaultLayout = this.locationConfigService.getLayout('current-layout');
    // this.locationConfigService.removeLayout(defaultLayout);
    return Number((defaultLayout && defaultLayout.layoutIndex) || 0);
  }
}
